// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.OrderPre-Dialog {\n    width: 1200px;\n    position: absolute;\n    left: 50%;\n    top: 0%;\n    transform: translateX(-50%);\n    border-radius: 15px;\n    box-shadow: 0 0 3px rgb(0 0 0 / 50%);\n    background-color: white;\n}\n.OrderPre-Dialog .el-dialog__header {\n    display: none;\n}\n.OrderPre-Dialog .el-dialog__body {\n    display: flex;\n    padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
